import { render, staticRenderFns } from "./FieldCustomerDeliveryCity.vue?vue&type=template&id=cf58aa2e&"
import script from "./FieldCustomerDeliveryCity.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerDeliveryCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports